/** @format */

import { useApiLoadingStore } from "../store/useApiLoadingStore";

/** True when any API request is in flight (driven by axios interceptors). */
export function useGlobalLoading(): boolean {
  const pendingCount = useApiLoadingStore((s) => s.pendingCount);
  return pendingCount > 0;
}
